import * as React from 'react';

const ShareIosChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 16v2H6v-2H4v4h16v-4zM12 4L7 9l1.4 1.4L11 7.8V16h2V7.8l2.6 2.6L17 9l-5-5z"
        />
    </svg>
);

ShareIosChunkySvg.displayName = 'ShareIosChunkySvg';
export default ShareIosChunkySvg;
